<div class="container login-page">
  <div class="row justify-content-center align-items-center login-layout">

    <!-- Loading spinner (kept out of form) -->
    <div class="text-center" [hidden]="!isLoading">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <!-- Login card -->
    <div
      class="card login-card"
      [hidden]="isLoading"
      [class.SmallArabicFont]="globalService.isRTL === true"
    >
      <div class="login-welcome" *ngIf="firstTime === false && agreementLink === ''">
        <div class="login-emblem"><img *ngIf="churchLogo" [src]="churchLogo" alt="" (error)="churchLogo = ''" /><i *ngIf="!churchLogo" class="fas fa-church" aria-hidden="true"></i></div>
        <p class="login-church">{{ displayChurchName }}</p>
        <h1>{{ ('WELCOME_BACK' | translate) }}</h1>
        <p>{{ displayWelcome || ('A_PLACE_TO_BELONG_A_COMMUNITY_TO_GROW_WITH' | translate) }}</p>
        <div class="login-highlights"><i class="fas fa-calendar-alt" aria-hidden="true"></i><span>{{ displayHighlights || ('WORSHIP_COMMUNITY_CONNECTION' | translate) }}</span></div>
      </div>
      <div class="card-body MyCardBody rounded-bottom login-body">

        <!-- 🔑 Autofill-safe form -->
        <form
          #myForm="ngForm"
          autocomplete="on"
          role="form"
          name="loginForm"
          action="/login"
          method="post"
          (ngSubmit)="onSubmit(myForm)"
        >

          <!-- LOGIN SCREEN -->
          <div [hidden]="firstTime !== false || agreementLink !== ''">

            <h2 class="login-form-title">{{ ('SIGN_IN_TO_YOUR_ACCOUNT' | translate) }}</h2>
            <p class="login-form-intro" id="shared-account-note">{{ ('SHARED_CHURCH_SERVICES_SIGN_IN' | translate) }}</p>

            <div
              class="form-group row m-3"
              [class.text-right]="globalService.isRTL === true"
            >
              <label for="username">{{ ('EMAIL_OR_PHONE_NUMBER' | translate) }}</label>
              <input
                type="text"
                inputmode="text"
                id="username"
                class="form-control text-left mb-3"
                dir="ltr"
                name="username"
                ngModel
                required
                autocomplete="username"
                aria-describedby="shared-account-note"
                [placeholder]="'USERNAME' | translate"
              />

              <label for="password">{{ globalService.Get("PASSWORD") }}</label>
              <input
                type="password"
                inputmode="text"
                id="password"
                class="form-control text-left"
                dir="ltr"
                name="password"
                ngModel
                required
                minlength="6"
                autocomplete="current-password"
                [placeholder]="'PASSWORD' | translate"
              />
            </div>

            <div
              class="form-group m-3"
              [class.SmallArabicFont]="globalService.isRTL === true"
            >
              <app-user-message *ngIf="!failureClosed && error" type="error" [title]="('WE_COULDN_T_SIGN_YOU_IN' | translate)" [message]="globalService.Get(error) || error" [dismissible]="false">
                <div messageActions class="user-message-actions"><a class="btn btn-outline-primary" [routerLink]="['/', tenantSubdomain, 'resetrequest']">{{ globalService.Get('FORGOTPASSWORD') }}</a></div>
              </app-user-message>
              <div class="row">
                <div class="col-6">
                  <button class="btn btn-primary btn-block" type="submit" [disabled]="isLogging">
                    <i *ngIf="isLogging" class="fas fa-spinner fa-spin"></i>
                    {{ globalService.Get("LOGIN") }}
                  </button>
                </div>
                <div class="col-6">
                  <a
                    class="btn btn-outline-primary btn-block"
                    routerLink="/signup"
                  >
                    {{ globalService.Get("SIGNUP") }}
                  </a>
                </div>
              </div>
            </div>

          </div>
        </form>

        <p *ngIf="emailVerification" class="text-center"><a [routerLink]="['/', tenantSubdomain, 'email-access']" [queryParams]="{returnUrl:returnUrl}">{{ ('VERIFY_EMAIL_OR_RESEND_ACTIVATION_LINK' | translate) }}</a></p>
          <!-- FORGOT PASSWORD -->
        <div class="form-group text-small text-center">
          <a
            class="link pointer"
            [class.SmallArabicFont]="globalService.isRTL === true"
            [routerLink]="['/', tenantSubdomain, 'resetrequest']"
          >
            <small>{{ globalService.Get("FORGOTPASSWORD") }}</small>
          </a>
        </div>

        <!-- FIRST-TIME / AGREEMENT FLOW -->
        <div *ngIf="firstTime === false && agreementLink === ''" class="login-guest">
          <span>{{ ('JUST_VISITING' | translate) }}</span>
          <a [routerLink]="churchHomeUrl">{{ ('CONTINUE_AS_A_GUEST' | translate) }}</a>
        </div>
        <div
          [hidden]="
            isLoading ||
            !(firstTime === true || (agreementLink && agreementLink !== ''))
          "
          [class.SmallArabicFont]="globalService.isRTL === true"
        >
          <p class="text-center text-danger welcomeHeader">
            {{ displayChurchName }}
          </p>

          <p class="text-center text-secondary welcomeHeader">
            {{ globalService.Get("WELCOME") + ' ' + fullName }}
          </p>

          <p
            class="text-center text-secondary"
            *ngIf="agreementLink"
          >
            {{ globalService.Get("NEW_TERMS_MESSAGE") }}
          </p>

          <div class="form-group text-center mt-2">
            <div class="row">

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-success btn-block"
                  (click)="SetAsMembers()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("YES") }}
                </button>
              </div>

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-danger btn-block"
                  (click)="SetAsGuests()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("NO") }}
                </button>
              </div>

              <div
                class="col-12"
                *ngIf="overrideMembership > 0 || !firstTime"
              >
                <button
                  class="btn btn-primary btn-block"
                  (click)="Profile()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("PROCEED_WITH_LOGIN") }}
                </button>
              </div>

            </div>
          </div>

          <div
            class="row text-center mt-3 nomargin"
            *ngIf="agreementLink"
          >
            <div
              class="form-group col-10"
              [class.ml-4]="!globalService.isRTL"
              [class.mr-4]="globalService.isRTL"
            >
              <input
                type="checkbox"
                class="form-check-input mt-2"
                (click)="AcceptAgreement()"
              />
              <label class="form-check-label">
                {{ globalService.Get("AGREE_TO_TERMS") }}
                <a [href]="agreementLink">
                  {{ globalService.Get("CLICK_TO_REVIEW") }}
                </a>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
